<div class="mb-2 text-center">
  <fgbcl-errors></fgbcl-errors>
</div>

<button (click)="loginSportsIllustrated()" class="btn btn-success btn-block font-size-14 w-100 fw-bold mb-2 mt-4 mt-lg-0">
  {{ 'user.login.sports.alliance' | translate }}
</button>
